import './index.scss';

import { CountUp } from 'countup.js';

class IcongridCountUp {
    constructor(root) {
        this.root = root;
        this.root.querySelectorAll('.icongrid__item .wrap').forEach(node => {
            switch (node.dataset.countupMode) {
                case 'countDownFromCurYear': this.countDownFromCurYear(node); break;
                case 'countUpNoFormat': this.countUpNoFormat(node); break;
                default: this.countUp(node);
            }
        });
    }

    countDownFromCurYear(node) {
        let title = node.querySelector('.title');
        if (!title) { return; }

        let value = parseInt(node.dataset.countupValue);
        if (isNaN(value)) { return; }

        let countUp = new CountUp(title, value, {
            startVal: new Date().getFullYear(),
            separator: '',
            enableScrollSpy: true,
            scrollSpyOnce: true,
        });

        if (countUp.error) { return; }
        countUp.start();
    }

    countUpNoFormat(node) {
        let title = node.querySelector('.title');
        if (!title) { return; }

        let value = parseInt(node.dataset.countupValue);
        if (isNaN(value)) { return; }

        let countUp = new CountUp(title, value, {
            separator: '',
            prefix: node.dataset.countupPrefix,
            suffix: node.dataset.countupSuffix,
            enableScrollSpy: true,
            scrollSpyOnce: true,
        });

        if (countUp.error) { return; }
        countUp.start();
    }

    countUp(node) {
        let title = node.querySelector('.title');
        if (!title) { return; }

        let value = parseFloat(node.dataset.countupValue.replace(/,/, '.'));
        if (isNaN(value)) { return; }

        let decim = 0;
        if (node.dataset.countupValue.includes(',')) {
            decim = node.dataset.countupValue.split(',')[1].length;
        }

        let countUp = new CountUp(title, value, {
            separator: '.',
            prefix: node.dataset.countupPrefix,
            suffix: node.dataset.countupSuffix,
            decimal: ',',
            decimalPlaces: decim,
            enableScrollSpy: true,
            scrollSpyOnce: true,
        });

        if (countUp.error) { return; }
        countUp.start();
    }
}

window.app.run(() => {
    document.querySelectorAll('.icongrid__list.theme-count-up').forEach((node) => {
        new IcongridCountUp(node);
    });
});
